import { render, staticRenderFns } from "./ScoreQuiz.vue?vue&type=template&id=7d4a3a33&scoped=true"
import script from "./ScoreQuiz.vue?vue&type=script&lang=js"
export * from "./ScoreQuiz.vue?vue&type=script&lang=js"
import style0 from "./ScoreQuiz.vue?vue&type=style&index=0&id=7d4a3a33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4a3a33",
  null
  
)

export default component.exports